import { render } from "./speechRecognition.vue?vue&type=template&id=118bc29e&scoped=true"
import script from "./speechRecognition.vue?vue&type=script&lang=js"
export * from "./speechRecognition.vue?vue&type=script&lang=js"

import "./speechRecognition.vue?vue&type=style&index=0&id=118bc29e&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-118bc29e"]])

export default __exports__